// gtm
export const ADD_TO_CART = 'add_to_cart';
export const ADD_TO_CART_ALL = 'add_to_cart_all';
export const ADD_TO_CART_ORDER_HISTORY = 'add_to_cart_order_history';
export const ADD_TO_CART_UPSELL = 'add_to_cart_upsell';
